export default {
  labels: {
    selectOne: 'Kies een opsie',
    selectAll: 'Kies alle toepaslike opsies',
    typeResponse: 'Tik jou antwoord in die onderstaande tekskassie.',
    recordResponse: "Maak 'n opname om die vraag te beantwoord.",
    enterNumeric: 'Voer ’n numeriese antwoord in die veld hieronder in.',
    rateResponseScale: 'Beoordeel jou antwoord op die gegewe skaal.',
    sliderMinimum: 'Minimumwaarde: {value}',
    sliderMaximum: 'Maksimumwaarde: {value}',
    selectOneOptionRow: 'Kies een opsie in elke ry.',
    selectAllOptionsRow: 'Kies alle toepaslike opsies vir elke ry.',
    dragAndDropResponse: 'Sleep en laat val die opsies om hulle volgens voorkeur te rangskik.',
    rankOrderDesktopInstruction: "Sleep en los items om hulle te rangeer, of gebruik die +-knoppie om 'n item by te voeg. Gebruik die pyltjieknoppies om te herrangeer of die skrapknoppie om 'n item te verwyder.",
    alert: "Waarskuwing",
    error: "Voer asseblief 'n getal tussen {min} en {max} in.",
    cameras: 'Kameras',
    microphones: 'Mikrofone',
    recording: 'Opname',
    noDevicesFound: 'Geen toestelle gevind nie',
    camera: 'Kamera',
    microphone: 'Mikrofoon',
    stopRecording: 'Stop opname',
    startRecording: 'Begin opname',
    disableCamera: 'Deaktiveer kamera',
    enableCamera: 'Aktiveer kamera',
    disableMicrophone: 'Deaktiveer mikrofoon',
    enableMicrophone: 'Aktiveer mikrofoon',
    settings: 'Instellings',
    recordingProgress: 'Opname vordering',
    playbackProgress: 'Afspeelvordering',
    play: 'Speel af',
    pause: 'Pouseer',
    stop: 'Stop',
    record: 'Opneem',
    recordAgain: 'Neem weer op',
    retry: 'Probeer weer',
    done: 'Klaar',
    minRecordTime: "Neem asseblief 'n antwoord vir {min} sekondes op.",
    enlargeImage: 'Vergroot prent',
    enlargedImage: 'Vergrote prent',
    close: 'Maak toe',
    zoomIn: 'Zoem in',
    zoomOut: 'Zoem uit',
    resetZoom: 'Stel zoem terug',
    zoomLevel: 'Zoem {percentage}%',
    imagePosition: '{current} van {total}',
    previousImage: 'Vorige prent',
    nextImage: 'Volgende prent',
    imageLoading: 'Laai prent',
    imageLoadFailed: 'Prent kon nie gelaai word nie',
  },
  noSelection: "Geen keuse gemaak nie",
  actions: {
    increase: 'Verhoog',
    decrease: 'Verminder'
  },
  survey: {
    endOfSurvey: {
      titleTerminated: 'Opname-voorskou Beëindig',
      titleCompleted: 'Opname-voorskou Voltooi',
      previewModeWarning: 'Hierdie bladsy is slegs sigbaar in Voorskou-modus en sal nie aan regte respondente gewys word nie.',
      reachedEndPoint: 'Hierdie opname het \'n eindpunt bereik.',
      reachedEndPointCompleted: 'Hierdie voorskou het \'n eindpunt bereik.',
      returnToModify: 'Keer terug na die vorige vraag om jou antwoorde te wysig en \'n ander opname-pad te toets.',
      logic: 'Logika'
    }
  }
}
